import produce from 'immer';

import en_us from 'shared/messages/compiled/en_us.json'
import de_at from 'shared/messages/compiled/de_at.json'
import fr_fr from 'shared/messages/compiled/fr_fr.json'
import es_es from 'shared/messages/compiled/es_es.json'
import zh_cn from 'shared/messages/compiled/zh_cn.json'
import pt_br from 'shared/messages/compiled/pt_br.json'
import pl_pl from 'shared/messages/compiled/pl_pl.json'
import it_it from 'shared/messages/compiled/it_it.json'
import hu_hu from 'shared/messages/compiled/hu_hu.json'
import nl_nl from 'shared/messages/compiled/nl_nl.json'
import cs_cz from 'shared/messages/compiled/cs_cz.json'

import {
  SELECT_LOCALE,
  SET_UPPERCASE_LABELS
} from 'shared/actions/types';

const initialState = {
  locale: 'en-us',
  messages: en_us,
  uppercase_labels: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_LOCALE:
      return produce(state, draft => {
        draft.locale = action.payload;
        switch (draft.locale) {
          case 'de-at':
            draft.messages = de_at;
            break
          case 'fr-fr':
            draft.messages = fr_fr;
            break
          case 'es-es':
            draft.messages = es_es;
            break
          case 'zh-cn':
            draft.messages = zh_cn;
            break
          case 'pt-br':
            draft.messages = pt_br;
            break
          case 'pl-pl':
            draft.messages = pl_pl;
            break
          case 'it-it':
            draft.messages = it_it;
            break
          case 'hu-hu':
            draft.messages = hu_hu;
            break
          case 'nl-nl':
            draft.messages = nl_nl;
            break
          case 'cs-cz':
            draft.messages = cs_cz;
            break
          default:
            draft.messages = en_us;
        }
      });

    case SET_UPPERCASE_LABELS:
      return produce(state, draft => {
        draft.uppercase_labels = action.payload;
      });

    default:
      return state;
  }
}
